import { Expose } from 'class-transformer';

/**
 * Cache 用户状态模型(数据来源：query_user_cache_status，由 fastescrow 提供)
 * 注意：is_eligible_cache / is_popup_for_resign 已由后端移入 query_homepage_info_new(BFF 6.1)，
 * 见 stores/home/home.model.ts；本接口现仅返回 is_cache_user。
 */
export class CacheStatusModel {
  /** 是否 Cache 用户(已签新合约 + 白名单)，来自 is_cache_user，控制是否展示 Cache UI */
  @Expose()
  isCacheUser!: boolean;
}
